export default (context:any) => {
    const moduleId = context.getters.moduleId;

    const startDate = context.rootState[`${ moduleId }_complaint-start`];
    const endDate = context.rootState[`${ moduleId }_complaint-end`];

    let validity = { ...startDate.validity };

    if (startDate.value.length > 0 && endDate.value.length > 0) {
        const durationStart = new Date(startDate.value);
        const durationEnd = new Date(endDate.value);
        validity = {
            ...validity,
            invalidDuration: durationStart > durationEnd,
        };
    } else {
        validity = {
            ...validity,
            invalidDuration: false,
        };
    }

    return validity;
};